<form
  class="form-group odd"
  id="income_name_field_box"
  [formGroup]="incomeForm"
>
  <label
    class="col-sm-3 control-label"
    for="name"
    id="income_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ incomeI18n.nameI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="income_name_input_box">
    <!-- income text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
      formControlName="name"
      id="field-income_name"
      name="name"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <!-- income Validation message -->
    <div *ngIf="submitted && f.name.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.name.errors.required">
        {{ msg.validationMessage.name }}
      </div>
    </div>
  </div>

  <label
    class="col-sm-3 control-label"
    for="name"
    id="income_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ incomeI18n.dateI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="income_name_input_box">
    <!-- income text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.date.errors }"
      formControlName="date"
      id="field-income_name"
      name="date"
      class="form-control"
      type="date"
      maxlength="99"
    />
    <!-- income Validation message -->
    <div *ngIf="submitted && f.date.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.date.errors.required">
        {{ msg.validationMessage.date }}
      </div>
    </div>
  </div>

  <label
    class="col-sm-3 control-label"
    for="name"
    id="income_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ incomeI18n.amountI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="income_name_input_box">
    <!-- income text field-->
    <input
      [ngClass]="{ 'is-invalid': submitted && f.amount.errors }"
      formControlName="amount"
      id="field-income_name"
      name="amount"
      class="form-control"
      type="text"
      maxlength="99"
    />
    <!-- income Validation message -->
    <div *ngIf="submitted && f.amount.errors" class="alert alert-danger">
      <div *ngIf="submitted && f.amount.errors.required">
        {{ msg.validationMessage.amount }}
      </div>
    </div>
  </div>
  <label
    class="col-sm-3 control-label"
    for="name"
    id="income_name_display_as_box"
  >
    <font style="vertical-align: inherit">
      <font style="vertical-align: inherit">
        {{ incomeI18n.noteI18n }}
      </font> </font
    ><span class="required">
      <font style="vertical-align: inherit">
        <font style="vertical-align: inherit">*</font>
      </font>
    </span>
  </label>
  <div class="col-sm-9 col-md-6 col-lg-6" id="income_name_input_box">
    <!-- income text field-->
    <textarea
      formControlName="note"
      id="field-income_name"
      name="note"
      class="form-control"
      type="text"
      maxlength="99"
    ></textarea>
    <!-- income Validation message -->
  </div>
  <!-- submit button -->
  <br />
  <button (click)="add()" type="button" class="btn btn-info">
    <i class="fas fa-save"></i>
    {{ incomeI18n?.addButtonI18n }}
  </button>
</form>
